import { isChrome, isFirefox } from 'react-device-detect';

import { API_URL } from '../config';

const getBrowser = () => {
  if (isChrome) return 'CHROME';
  if (isFirefox) return 'FIREFOX';
  return null;
};

export const sendSubscription = data => {
  if (data.channel === 'FROM_SW' && data.type === 'BussinessWebApp') {
    const browser = getBrowser();

    if (browser) {
      const body = { ...JSON.parse(data.subscription), browser };

      fetch(`${API_URL}/wp/`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-TOKEN': ''
        },
        body: JSON.stringify(body)
      })
        .catch(error => console.log(error));
    }
  }
};